import React, { useState } from 'react';
import { ChevronDown, ChevronUp, EyeOff, Star } from 'lucide-react';
import { HostBannerCarousel } from '@/components/HostBannerCarousel';

const KEY = 'ee_dash_banners';

export const DashboardBanners = () => {
    const [mode, setMode] = useState(() => localStorage.getItem(KEY) || 'open');
    const [count, setCount] = useState(null);
    const set = (m) => { setMode(m); localStorage.setItem(KEY, m); };
    if (count === 0) return null;
    if (mode === 'hidden') {
        return (
            <>
                {count > 0 && <button type="button" onClick={() => set('open')} className="mb-4 text-xs text-muted-foreground hover:text-foreground underline" data-testid="dashboard-banners-show">Show featured banners</button>}
                <div className="hidden"><HostBannerCarousel bare onCount={setCount} /></div>
            </>
        );
    }
    return (
        <div className="mb-6" data-testid="dashboard-banners">
            <div className="flex items-center justify-between mb-2">
                <div className="flex items-center gap-2 text-xs uppercase tracking-[0.18em] text-muted-foreground"><Star className="h-3.5 w-3.5 text-amber-500" /> Featured</div>
                <div className="flex gap-1">
                    <button type="button" onClick={() => set(mode === 'min' ? 'open' : 'min')} className="inline-flex items-center gap-1 rounded-md px-2 py-1 text-xs text-muted-foreground hover:bg-secondary" data-testid="dashboard-banners-minimize">
                        {mode === 'min' ? <><ChevronDown className="h-3.5 w-3.5" /> Expand</> : <><ChevronUp className="h-3.5 w-3.5" /> Minimise</>}
                    </button>
                    <button type="button" onClick={() => set('hidden')} className="inline-flex items-center gap-1 rounded-md px-2 py-1 text-xs text-muted-foreground hover:bg-secondary" data-testid="dashboard-banners-hide"><EyeOff className="h-3.5 w-3.5" /> Hide</button>
                </div>
            </div>
            <div className={mode === 'min' ? 'hidden' : ''}><HostBannerCarousel bare onCount={setCount} /></div>
        </div>
    );
};
